import React, { useEffect, useState } from "react";

const LocalTimeWithLocation = () => {
  const [time, setTime] = useState("");
  const [location, setLocation] = useState("");

  useEffect(() => {
    // Get user's timezone
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // Extract just the city from "Continent/City"
    const city = tz.split("/")[1]?.replace("_", " ") || "Unknown Location";
    setLocation(city);

    const updateTime = () => {
      const now = new Date();
      const localTime = new Intl.DateTimeFormat("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      }).format(now);
      setTime(localTime);
    };

    updateTime();
    const interval = setInterval(updateTime, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section style={styles.section}>
      <h3> {location}</h3>
      <p style={styles.time} className="time">{time}</p>
    </section>
  );
};

const styles = {
  section: {
    textAlign: "center",
     padding:0,
      
    fontFamily: "sans-serif",
     
    height:"max-content",
    width:"max-content",
    display:"flex",
    alignItems:"center",
    gap:"15px"
  },
  time: {
    fontSize: "1rem",
     
    fontWeight: "bold",
  },
};

export default LocalTimeWithLocation;
